import React, { ComponentProps } from 'react';
import { Flex, Image, Text } from '@qga/roo-ui/components';

import { hotelBed } from '@/v2/components/icons';

const MissingImage = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex
      gap="2"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bg="greys.cloud"
      height="200px"
      p="3"
      {...props}
    >
      <Image alt="" src={hotelBed} size="2.5rem" />
      <Text
        textAlign="center"
        fontWeight="bold"
        fontSize="base"
        lineHeight="1.5"
      >
        Sorry, we can&apos;t find any images
      </Text>
    </Flex>
  );
};

export default MissingImage;
